import { ref, onBeforeUnmount } from 'vue'
import { useCommonStore } from '@stores/common';

const defaultId = '701590062918-oaaghtugi1rhafiriq08uqc88q385mcn.apps.googleusercontent.com';

export const backPageType = {
  register: 1, // 注册页面config._apiPath
  login: 2, // 登录页面
  account: 3 // 账户页面
}

const localeEnum = {
  es: ['MX', 'CO', 'CL', 'PE', 'EC', 'AR'],
  pt: ['BR',],
  en: ['PH', 'NG']
}


const clientIdEnum = {
  // 墨西哥配置
  '777suerte': '418032295598-qcge51osfkhdb4lj4kq3otjckjgkn58l.apps.googleusercontent.com',
  '777jugar': '624516988079-ii87labg3gfc7skhhfprr53mknv1151u.apps.googleusercontent.com',
  'lanawin': '988850458180-n519rmuc62abkg7s19a6jrmh4n8ce9t4.apps.googleusercontent.com',
  'mxjugar': '443772752690-2r749i8g68857196gafn81dkrbddnf4q.apps.googleusercontent.com',
  'mxgana': '739810906027-5hmj4d8r9jo4mgceah91topfa22iq6gk.apps.googleusercontent.com',
  'jugarmx': '1083979892377-cht2n1t6o311i6c6cr0802rid2gpuq5s.apps.googleusercontent.com',
  '001mx': '314006983004-dl8kd1q6vvs1q1fk1o2kp89ckb320k8s.apps.googleusercontent.com',
  // 阿根廷配置 和 jugarcol一样，已经产品确认 GLBYjugarcol
  'ar': '163971147813-fhnbm0hi7ni8jrcfke3m454kmrqedpas.apps.googleusercontent.com',
  'suenobet': '163971147813-fhnbm0hi7ni8jrcfke3m454kmrqedpas.apps.googleusercontent.com',
  // 墨西哥新加的产线
  'winmx001': '305938965558-oauv9lglqafroesl9l2dm3t216bu44iq.apps.googleusercontent.com',
  'winmx888': '427379690977-191vob7gipfdd5tf1e77bmgiuej9t6c4.apps.googleusercontent.com',
  'mxbet100': '384437025298-a712u7v36csn8o6os6qd50v6u9a9511e.apps.googleusercontent.com',
  // 格伦比亚配置
  'jugarco': '927306467492-8n0kvrq5e97dfhicbl9qdb43sd3u3b18.apps.googleusercontent.com',
  'suerteco': '5672808788-5po0c5708j3jqfdcpprbrbbh6e7cq62h.apps.googleusercontent.com',
  'apostarco': '495024324444-v0aqt5rj5hihaa8qpv93p98sf6eba9u3.apps.googleusercontent.com',
  'suertecol': '655595596215-f31dkevoscccphprp5bp2e13rlkm4b5m.apps.googleusercontent.com',
  // 已经产品确认 GLBYjugarcol
  'jugarcol': '163971147813-fhnbm0hi7ni8jrcfke3m454kmrqedpas.apps.googleusercontent.com',
  // 智利配置
  'vinacl': '542836978659-2va17cvpiag03fvninme941sgqnn0itu.apps.googleusercontent.com',
  'enjoycl': '505891209148-cdoi175apfp6pdmt5ravl0td5j503bju.apps.googleusercontent.com',
  'clluckia': '367134242382-t21nnh9p0e0bd9drs81s9bsjg6b7eve1.apps.googleusercontent.com',
  'coquimbocl': '895425042490-gse9aq816s9alt92ecf7feasvihe0ojs.apps.googleusercontent.com',
  // 秘鲁配置
  'pefiesta': '617254650716-cndk86bcmo5vkl4qdfuv3cj4u75urhtm.apps.googleusercontent.com',
  'peluckie': '980149068822-qk65o7h665rtp2poktvc47t3ja1bc21v.apps.googleusercontent.com',
  'lahaciendape': '42789949541-hlveoq70ulq59d2a83s6vfjph1lb5pnk.apps.googleusercontent.com',
  'peluckia': '795580356892-blfdij6nbgjbou8maj35vf2islaall3f.apps.googleusercontent.com',
  'pefortuna': '394804499834-0gnic1fkndv1d80tb7hd9bk1v8pou1at.apps.googleusercontent.com'
}

const getCurLocale = (checkSiteConfigRes) => {
  const locale = uni.getLocale()
  let curLocale = '';
  for (let key in localeEnum) {
    if (localeEnum[key].includes(checkSiteConfigRes?.country)) {
      curLocale = key;
      break;
    }
  }
  return curLocale || locale;
}

const getCurClientId = (checkSiteConfigRes) => {
  const siteCode = checkSiteConfigRes.siteCode?.toLowerCase();
  return clientIdEnum[siteCode] || defaultId;
}

console.log('PELUCKIE'.toLowerCase() === 'peluckie')
export function useGoogle() {
  const googleAuthInstance = ref(null)
  const isScriptLoaded = ref(false)
  const isLoading = ref(false)
  const error = ref(null)

  const { checkSiteConfigRes } = useCommonStore();
  const curLocale = getCurLocale(checkSiteConfigRes);
  const curClientId = getCurClientId(checkSiteConfigRes);

  const loadGoogleScript = () => {
    return new Promise((resolve, reject) => {
      if (window.google?.accounts?.id) {
        isScriptLoaded.value = true
        resolve()
        return
      }

      const script = document.createElement('script')
      script.src = `https://accounts.google.com/gsi/client?hl=${curLocale}`
      script.async = true
      script.defer = true
      script.onload = () => {
        isScriptLoaded.value = true
        resolve()
      }
      script.onerror = (err) => {
        error.value = 'Failed to load Google Sign-In script'
        console.error('Google Sign-In script error:', err)
        reject(err)
      }
      document.head.appendChild(script)
    })
  }

  const initializeGoogleAuth = (params) => {
    if (!window.google?.accounts?.id) {
      console.error('Google Sign-In script not loaded')
      error.value = 'Google Sign-In script not loaded'
      return false
    }

    // Default parameters
    const defaultParams = {
      // client_id: '416443129753-cg76ahed7eipdqkc4kbj998i75ej30et.apps.googleusercontent.com',
      client_id: curClientId,
      click_listener: () => { },
      context: 'signin',
      ux_mode: 'popup',
      itp_support: true,
      auto_select: false,
      callback: (res) => {
        console.log('Google Sign-In callback:', res)
        // Handle the sign-in response here
      },
    }

    const mergedParams = { ...defaultParams, ...params, login_uri: process.env.NODE_ENV === 'development' ? params.login_uri : `${location.origin}/proxy-api/auth/user/login/google` }

    if (googleAuthInstance.value) {
      window.google.accounts.id.cancel()
    }

    window.google.accounts.id.initialize(mergedParams)
    googleAuthInstance.value = window.google.accounts.id
    return true
  }

  const renderButton = (element, params) => {
    if (!googleAuthInstance.value || !element) {
      error.value = 'Google Auth not initialized or element not provided'
      console.error('Google button not rendered:', error.value)
      return false
    }

    const defaultButtonParams = {
      type: 'standard',
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
      shape: 'rectangular',
      logo_alignment: 'left',
      locale: curLocale
    }

    const mergedButtonParams = { ...defaultButtonParams, ...params }

    try {
      googleAuthInstance.value.renderButton(element, mergedButtonParams)
      // const googleButton  = document.querySelector('.nsm7Bb-HzV7m-LgbsSe .nsm7Bb-HzV7m-LgbsSe-Bz112c-haAclf')
      // if (googleButton) googleButton.style.backgroundColor = 'transparent'
      return true
    } catch (err) {
      error.value = 'Failed to render Google button'
      console.error('Google button render error:', err)
      return false
    }
  }


  const promptOneTap = (options = {}) => {
    if (!googleAuthInstance.value) {
      error.value = 'Google Auth not initialized'
      return false
    }

    try {
      googleAuthInstance.value.prompt(options)
      return true
    } catch (err) {
      error.value = 'Failed to prompt One Tap'
      return false
    }
  }

  const disableAutoSelect = () => {
    if (googleAuthInstance.value) {
      googleAuthInstance.value.disableAutoSelect()
    }
  }

  const revokeAccess = (hint, callback) => {
    if (googleAuthInstance.value) {
      googleAuthInstance.value.revoke(hint, callback)
    }
  }

  onBeforeUnmount(() => {
    if (googleAuthInstance.value) {
      googleAuthInstance.value.cancel()
    }
  })

  return {
    loadGoogleScript,
    initializeGoogleAuth,
    renderButton,
    promptOneTap,
    disableAutoSelect,
    revokeAccess,
    isScriptLoaded,
    isLoading,
    error,
    googleAuthInstance
  }
}